import shiptypeComponent from './shiptype.component';
import ShiptypeCreate from './create'
import ShiptypeEdit from './edit'
import ShiptypeAll from './all'

let shiptypeModule = angular.module('shiptype', [
    ShiptypeCreate,
    ShiptypeEdit,
    ShiptypeAll
  ])

  .component('shiptype', shiptypeComponent)

  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    $stateProvider
      .state('shiptype.edit', {
        url: '/edit/:id',
        component: 'shiptypeedit',
        data: {
          requireACL: 'tnt_control_shiptype.edit'
        }
      })

      .state('shiptype.create', {
        url: '/create',
        component: 'shiptypecreate',
        data: {
          requireACL: 'tnt_control_shiptype.create'
        }
      })

      .state('shiptype.all', {
        url: '/all/:page',
        component: 'shiptypeall',
        data: {
          requireACL: 'tnt_control_shiptype.view'
        }        
      })
  })

  .name;

export default shiptypeModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/shiptype/index.js